const initialState = {
  isRequestingCrealEspecies: false,
  isRequestingCrealEspecie: false,
  isRequestingBiotecnologias: false,
  isRequestingCrealVariedades: false,
  cerealEspecies: [],
  cerealEspecie: null,
  biotecnologias: [],
  cerealVariedades: [],
  selectedCerealEspecie: null,
  selectedBiotecnologia: null,
  selectedCerealVariedad: 'UNDEF'
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'REQUEST_CEREAL_ESPECIE':
      return {
        ...state,
        isRequestingCrealEspecie: true
      }
    case 'RECEIVE_CEREAL_ESPECIE':
      return {
        ...state,
        isRequestingCrealEspecies: false,
        cerealEspecie: action.cerealEspecie
      }
    case 'REQUEST_CEREAL_ESPECIES':
      return {
        ...state,
        isRequestingCrealEspecies: true
        // selectedCerealEspecie: null
      }
    case 'RECEIVE_CEREAL_ESPECIES':
      return {
        ...state,
        isRequestingCrealEspecies: false,
        cerealEspecies: action.cerealEspecies
      }
    case 'REQUEST_BIOTECNOLOGIAS':
      return {
        ...state,
        isRequestingBiotecnologias: true,
        selectedBiotecnologia: null
      }
    case 'RECEIVE_BIOTECNOLOGIAS':
      return {
        ...state,
        isRequestingBiotecnologias: false,
        biotecnologias: action.biotecnologias
      }
    case 'SET_BIOTECNOLOGIA':
      return {
        ...state,
        selectedBiotecnologia: action.biotecnologia
      }
    case 'REQUEST_CEREAL_VARIEDADES':
      return {
        ...state,
        isRequestingCrealVariedades: true,
        cerealVariedades: []
      }
    case 'RECEIVE_CEREAL_VARIEDADES':
      return {
        ...state,
        isRequestingCrealVariedades: false,
        cerealVariedades: action.cerealVariedades
      }
    case 'SET_CEREAL_ESPECIE':
      return {
        ...state,
        selectedCerealEspecie: action.cerealEspecie
      }
    default:
      return state
  }
}
